import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";

import BaseCard from "./components/UI/BaseCard.vue";

loadFonts();

const app = createApp(App);

app.component("base-card", BaseCard);
app.use(router);
app.use(vuetify);
app.mount("#app");
